// Packages Imports
import moment from 'moment';

// Project Imports
import SocketEvent from 'core/constants/SocketEvent';
import openNotificationWithIcon from 'core/utils/notification';

function updateOrAddNotificationMsg(notificationArray, newNotificationMsg) {
  // Find the index of the object that has the matching key and value
  const index = notificationArray?.findIndex(
    (obj) => obj?.uniqueId === newNotificationMsg?.uniqueId
  );

  if (index !== -1) {
    // If newNotificationMsg is found in notificationArray, update the process with new newNotificationMsg
    // eslint-disable-next-line no-param-reassign
    notificationArray[index] = newNotificationMsg;
  } else {
    // If newNotificationMsg is not found, add the newNotificationMsg to the notificationArray
    notificationArray?.push(newNotificationMsg);
  }

  return notificationArray;
}

const updateNotifications = (
  newMessage,
  userId,
  id,
  setNotificationMessages,
  toggleSocketNotifications
) => {
  const updatedNewMessage = { ...newMessage };
  if (updatedNewMessage.timestamp) {
    const adjustedTimestamp = moment(updatedNewMessage.timestamp)
      .add(5, 'hours')
      .add(30, 'minutes')
      .format('YYYY-MM-DD HH:mm:ss');
    updatedNewMessage.timestamp = adjustedTimestamp;
  }

  const notificationList = localStorage.getItem('notifications');
  const notificationLocalstorage =
    JSON.parse(notificationList)?.length > 0
      ? JSON.parse(notificationList)
      : [];
  const updatedMessages = updateOrAddNotificationMsg(
    notificationLocalstorage,
    updatedNewMessage
  );
  if (updatedMessages?.length > notificationLocalstorage?.length) {
    // show notification if new message added
    openNotificationWithIcon(
      updatedNewMessage.status,
      updatedNewMessage?.title,
      updatedNewMessage?.message
    );
  }
  if (userId === id) {
    localStorage.setItem('notifications', JSON.stringify(updatedMessages));
    setNotificationMessages(updatedMessages);
    toggleSocketNotifications(updatedNewMessage?.title);
  }
};
const setNotificatons = async (
  setNotificationMessages,
  userDetails,
  socketInstance,
  toggleSocketNotifications
): Promise<void> => {
  try {
    socketInstance.on('status_update', (data) => {
      const newMessage = {
        title: data?.event_name,
        timestamp: data?.date_time,
        message: data?.message,
        status: data?.status,
        userId: data?.userId,
        progress: data?.completion_percentage,
        uniqueId: data?.workflow_status_id,
        read: false,
        extraKeys: data?.extra_keys,
      };
      updateNotifications(
        newMessage,
        userDetails?.unique_id,
        data?.userId,
        setNotificationMessages,
        toggleSocketNotifications
      );
    });
    socketInstance.on(
      SocketEvent.INPUT_CONFIG_FILE_UPLOAD_EVENT_NAME,
      (data) => {
        const newMessage = {
          title: data?.event_name,
          timestamp: data?.date_time,
          message: data.message,
          status: data?.status,
          userId: data?.userId,
          filePath: data?.file_path,
          progress: data?.completion_percentage,
          uniqueId: data?.workflow_status_id,
          sourceId: data?.source_id,
          read: false,
          extraKeys: data?.extra_keys
            ? data?.extra_keys
            : {
                'file name ': data?.file_name,
                'file type ': data?.file_type,
              },
        };
        updateNotifications(
          newMessage,
          userDetails?.unique_id,
          data?.userId,
          setNotificationMessages,
          toggleSocketNotifications
        );
      }
    );
    socketInstance.on(SocketEvent.INPUT_SOURCE_CREATION_EVENT_NAME, (data) => {
      const newMessage = {
        title: data?.event_name,
        timestamp: data?.date_time,
        message: data.message,
        status: data?.status,
        userId: data?.userId,
        progress: data?.completion_percentage,
        uniqueId: data?.workflow_status_id,
        sourceId: data?.source_id,
        read: false,
        extraKeys: data?.extra_keys,
      };
      updateNotifications(
        newMessage,
        userDetails?.unique_id,
        data?.userId,
        setNotificationMessages,
        toggleSocketNotifications
      );
    });
    socketInstance.on(
      SocketEvent.INPUT_CUSTOM_COLUMN_CREATION_EVENT_NAME,
      (data) => {
        const newMessage = {
          title: data?.event_name,
          timestamp: data?.date_time,
          message: data.message,
          status: data?.status,
          userId: data?.userId,
          progress: data?.completion_percentage,
          uniqueId: data?.workflow_status_id,
          read: false,
          extraKeys: data?.extra_keys,
        };
        updateNotifications(
          newMessage,
          userDetails?.unique_id,
          data?.userId,
          setNotificationMessages,
          toggleSocketNotifications
        );
      }
    );
    socketInstance.on(
      SocketEvent.MASTER_CONFIG_FILE_UPLOAD_EVENT_NAME,
      (data) => {
        const newMessage = {
          title: data?.event_name,
          timestamp: data?.date_time,
          message: data.message,
          status: data?.status,
          userId: data?.userId,
          filePath: data?.file_path,
          progress: data?.completion_percentage,
          uniqueId: data?.workflow_status_id,
          sourceId: data?.source_id,
          read: false,
          extraKeys: data?.extra_keys,
        };
        updateNotifications(
          newMessage,
          userDetails?.unique_id,
          data?.userId,
          setNotificationMessages,
          toggleSocketNotifications
        );
      }
    );
    socketInstance.on(SocketEvent.MASTER_SOURCE_CREATION_EVENT_NAME, (data) => {
      const newMessage = {
        title: data?.event_name,
        timestamp: data?.date_time,
        message: data.message,
        status: data?.status,
        userId: data?.userId,
        sourceId: data?.source_id,
        progress: data?.completion_percentage,
        uniqueId: data?.workflow_status_id,
        read: false,
        extraKeys: data?.extra_keys,
      };
      updateNotifications(
        newMessage,
        userDetails?.unique_id,
        data?.userId,
        setNotificationMessages,
        toggleSocketNotifications
      );
    });
    socketInstance.on(
      SocketEvent.UNIFIED_SOURCE_CREATION_EVENT_NAME,
      (data) => {
        const newMessage = {
          title: data?.event_name,
          timestamp: data?.date_time,
          message: data.message,
          status: data?.status,
          userId: data?.userId,
          read: false,
          progress: data?.completion_percentage,
          uniqueId: data?.workflow_status_id,
          extraKeys: data?.extra_keys,
          sourceId: data?.source_id,
        };
        updateNotifications(
          newMessage,
          userDetails?.unique_id,
          data?.userId,
          setNotificationMessages,
          toggleSocketNotifications
        );
      }
    );
    socketInstance.on(
      SocketEvent.UNIFIED_CUSTOM_COLUMN_CREATION_EVENT_NAME,
      (data) => {
        const newMessage = {
          title: data?.event_name,
          timestamp: data?.date_time,
          message: data.message,
          status: data?.status,
          userId: data?.userId,
          read: false,
          progress: data?.completion_percentage,
          uniqueId: data?.workflow_status_id,
          extraKeys: data?.extra_keys,
        };
        updateNotifications(
          newMessage,
          userDetails?.unique_id,
          data?.userId,
          setNotificationMessages,
          toggleSocketNotifications
        );
      }
    );
  } catch (error) {
    console.log(error);
  }
};

export default setNotificatons;
